<template>
  <v-container>
    <v-layout row wrap class="mb-5">
      <v-flex xs12 md12>
        <v-layout>
          <h1 class="primary--text mr-3">States</h1>
          <v-btn small depressed color="accent" to="/states/create" v-if="$can('create_state')">
            <v-icon small>add</v-icon>Create State
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>

    <app-alert
      class="mb-3"
      type="success"
      message="State successfully created."
      v-if="$route.query.stateCreated"
    />
    <!-- <app-alert class="mb-3" type="success" :message="state.updated" /> -->

    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">All States</v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="states"
            :loading="isLoading"
            hide-actions
            no-data-text="No states available"
          >
            <template v-slot:items="props">
              <td> {{ (props.index + 1) }} </td>
              <td v-if="state.editing === props.item._id">
                <v-text-field
                  label="Name"
                  type="text"
                  v-model="state.cached.name"
                  @input="state.canSave = true"
                ></v-text-field>
              </td>
              <td v-else>{{ props.item.name }}</td>

              <td v-if="state.editing === props.item._id">
                <v-select
                  label="Status"
                  v-model="state.cached.status"
                  :items="statusOptions"
                  @input="state.canSave = true"
                ></v-select>
              </td>
              <td v-else>
                <v-chip
                  small
                  :color="props.item.status === 'active' ? 'green' : 'red'"
                  text-color="white"
                >{{ $lang(props.item.status) }}</v-chip>
              </td>

              <td v-if="state.editing === props.item._id">
                <v-btn
                  small
                  depressed
                  color="success"
                  @click="updateState()"
                  :disabled="state.isSaving || !state.canSave || !validName"
                >Save</v-btn>
                <v-btn small flat @click="cancelEdit()" :disabled="state.isSaving">Cancel</v-btn>
              </td>
              <td v-else>
                <v-icon small class="mr-2" @click="editMode(props.item)" v-if="$can('edit_state')">edit</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { STATE_FETCH, STATE_UPDATE } from '@/store/actions/state'
import { statusOptions } from '@/data/options'

export default {
  name: 'States',
  created () {
    this.isLoading = true
    this.$store.dispatch(STATE_FETCH)
      .finally(() => (this.isLoading = false))
  },
  data () {
    return {
      state: {
        editing: null,
        cached: null,
        updated: false,
        canSave: false,
        isSaving: false
      },
      isLoading: false,
      statusOptions: statusOptions,
      headers: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  methods: {
    editMode (state) {
      this.state.canSave = false
      this.state.updated = false
      this.state.editing = state._id
      this.state.cached = Object.assign({}, state)
      delete this.state.cached.created // removes the created timestamp
      delete this.state.cached.modified // removes the modified timestamp
    },
    updateState () {
      if (this.$validator.isRequired(this.state.cached.name) !== true) return
      this.state.isSaving = true
      this.$store.dispatch(STATE_UPDATE, this.state.cached)
        .then(() => {
          this.state.updated = 'State has been successfully updated.'
        })
        .finally(() => {
          this.state.canSave = false
          this.state.editing = null
          this.state.cached = null
          this.state.isSaving = false
        })
    },
    cancelEdit () {
      this.state.canSave = false
      this.state.editing = null
      this.state.cached = null
    }
  },
  computed: {
    validName () {
      return this.state.cached.name !== ''
    },
    ...mapGetters(['states'])
  }
}
</script>
